import React, { useEffect, useState } from "react";
import { Row, Col, Button, notification } from "antd";
import {
  AddTempGroceryCartPayload,
  GroceryItem,
} from "../../../types/GroceryTypes";
import styles from "./GroceryDelivery.module.scss";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import buttonStyles from "../../Shared/Styles/ButtonStyles.module.scss";
import addItemIcon from "../../../assets/icons/addItem.svg";
import { useGroceryCtx } from "../../../context/GroceryContext";
import EllipsisText from "../../../helpers/EllipsisText/EllipsisText";
import GroceryAddItems from "../GroceryAddItems/GroceryAddItems";
import {
  addTempGroceryCart,
  getTemporaryGroceryCart,
} from "../../../services/GroceryService";
import { useParams } from "react-router";

type Props = {
  align: "vertical" | "horizontal";
  groceryItem: GroceryItem;
  setIsOpenScheduleGroceryDrawer: Function;
};

enum GroceryCartAction {
  Add = 1,
  Subtract,
  Delete,
}

function GroceryItemView({
  align,
  groceryItem,
  setIsOpenScheduleGroceryDrawer,
}: Props) {
  const { isDeliveryScheduledCtx, cachedGroceryCartItemsCtx } = useGroceryCtx();
  const [isDeliveryScheduled] = isDeliveryScheduledCtx;
  const { personId } = useParams<{ personId: string }>();
  const [groceryAddAction, setGroceryAddAction] = useState<number | null>(null);
  const [
    cachedGroceryCartItems,
    setCachedGroceryCartItems,
  ] = cachedGroceryCartItemsCtx;
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const GroceryItemCount: number =
    cachedGroceryCartItems?.find(
      (e: { groceryId: number }): any => e.groceryId === groceryItem.groceryId
    )?.quantity ?? 0;
  const [currentCount, setCurrentCount] = useState<number>(GroceryItemCount);
  const [isDeleteBtnClick, setIsDeleteBtnClick] = useState<boolean>(false);

  const updateGroceryCart = async (groceryAddAction: number) => {
    const itemCount = 1;
    const requestBody: AddTempGroceryCartPayload = {
      serviceUserPersonId: Number(personId),
      groceryCartAction: groceryAddAction,
      groceryCart: {
        groceryId: groceryItem.groceryId,
        categoryName: groceryItem.categoryName,
        productName: groceryItem.productName,
        imageKey: groceryItem.imageKey,
        quantity: itemCount,
        weight: groceryItem.weight,
        weightType: groceryItem.weightType,
        size: groceryItem.size,
        cost: groceryItem.cost,
        costType: groceryItem.costType,
        totalCost: groceryItem.totalCost,
        minQty: groceryItem.minQty,
        maxQty: groceryItem.maxQty,
      },
    };

    const groceryCartCount = await addTempGroceryCart(requestBody);
    if (groceryAddAction === GroceryCartAction.Delete) {
      setCurrentCount(0);
    }
    return groceryCartCount;
  };

  useEffect(() => {
    if (groceryAddAction !== null && currentCount !== null) {
      const fetchTemporaryGroceryCart = async () => {
        try {
          await updateGroceryCart(groceryAddAction);          
          const tempGroceryCart = await getTemporaryGroceryCart(
            Number(personId)
          );
          setCachedGroceryCartItems(tempGroceryCart.getGroceryCarts);
        } catch (error) {
          notification.error({
            message: "Failed to fetching temporary grocery cart",
          });
        }
      };

      fetchTemporaryGroceryCart();
    }
  }, [isDeleteBtnClick]);

  function handleAddToCart() {
    !isDeliveryScheduled && setIsOpenScheduleGroceryDrawer(true);
    setGroceryAddAction(GroceryCartAction.Add);
    setCurrentCount(1);
    setIsDeleteBtnClick(!isDeleteBtnClick);
  }

  return (
    <>
      <Row
        className={
          align === "vertical"
            ? styles.groceryItemVerticalViewContainer
            : styles.groceryItemHorizontalViewContainer
        }
        onBlur={() => setIsClicked(false)}
        onFocus={() => setIsClicked(true)}
      >
        <Col
          span={align === "vertical" ? 24 : ""}
          className={
            align === "vertical" ? styles.marginDown8 : styles.marginRight16
          }
        >
          <Row justify="center" align="middle">
            {groceryItem.imageUrl ? (
              <img
                className={styles.groceryItemImage}
                src={groceryItem.imageUrl}
                alt="grocery_item"
              />
            ) : (
              <Col
                className={`${styles.defaultImage} ${textStyles.normalText20}`}
              >
                {groceryItem.productName[0].toUpperCase()}
              </Col>
            )}
          </Row>
        </Col>

        <Col span={align === "vertical" ? 24 : 0}>
          <Row justify="end">
            <Button className={buttonStyles.iconBtn} onClick={handleAddToCart}>
              <img src={addItemIcon} alt="add_Item" />
            </Button>
          </Row>
        </Col>

        <Col span={align === "vertical" ? 24 : ""}>
          <Row align="bottom" gutter={[4, 0]}>
            <Col className={textStyles.secondaryBoldText14}>
              ${groceryItem.cost}
            </Col>
            <Col className={textStyles.secondaryNormalText12}>
              {groceryItem.costType}
            </Col>
          </Row>

          <Row className={textStyles.normalText14}>
            <EllipsisText
              text={groceryItem.productName}
              maxVisibleTextLength={10}
            />
          </Row>

          {!!groceryItem.weight && (
            <Row className={textStyles.normalText14}>
              {groceryItem.weight} {groceryItem.weightType}
            </Row>
          )}
        </Col>

        <Col span={align === "vertical" ? 0 : 24}>
          <Row justify="end">
            <Col className={styles.addCartBtnContainer}>
              {isClicked && currentCount >= 1 ? (
                <GroceryAddItems
                  groceryItem={groceryItem}
                  groceryCartCount={currentCount}
                  currentCount={currentCount}
                  setCurrentCount={setCurrentCount}
                />
              ) : currentCount === 0 || currentCount === undefined ? (
                <Button
                  className={`${buttonStyles.defaultWhiteBtn} ${textStyles.normalText16}`}
                  onClick={handleAddToCart}
                >
                  Add to cart
                </Button>
              ) : (
                <Button className={styles.countButtonStyle}>
                  {currentCount}
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default GroceryItemView;
